/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/
 */

// You can delete this file if you're not using it
import './src/styles/main.scss'

export const onRouteUpdate = ({
  location
}) => {

  const loadBownow = () => {
    if (window.__bownowLoaded) return
    window.__bownowLoaded = true

    const script = document.createElement('script')
    script.async = true
    script.src = 'https://contents.bownow.jp/forms/sid_0553048ddd2cfb7d93ec/trace.js'
    document.getElementsByTagName('head')[0].appendChild(script)
  }

  const target = document.getElementById('_bownow_cs_sid_0553048ddd2cfb7d93ec')
  if (!target) return

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      if (entries.some((entry) => entry.isIntersecting)) {
        observer.disconnect()
        loadBownow()
      }
    })
    observer.observe(target)
  } else {
    // Fallback for older browsers
    setTimeout(loadBownow, 2000)
  }
}
